module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "3RocketLaunching.df79e9c8.svg";